import { Box, Stack } from '@mui/material'
import { ReactNode } from 'react'

const PTBox = ({
  title,
  content,
  theme,
}: {
  title: ReactNode
  content: ReactNode
  theme: any
}) => (
  <Stack mt={2} maxWidth={900}>
    <Box borderRadius={1}>
      <Stack
        sx={{
          backgroundColor: theme.palette.secondary.light,
          borderTopLeftRadius: 4,
          borderTopRightRadius: 4,
          py: 1,
          px: 2,
          width: 'fit-content',
        }}
      >
        {title}
      </Stack>
      <Box
        sx={{
          border: `1px solid ${theme.palette.secondary.light}`,
          borderRadius: 1,
          borderTopLeftRadius: 0,
          p: 2,
        }}
      >
        {content}
      </Box>
    </Box>
  </Stack>
)

export default PTBox
